import { Button, IconTitle, SpinnerUntil } from "@edgetier/components";
import { faBars, faTimes, faUserCog } from "@fortawesome/pro-solid-svg-icons";
import SignOut from "components-for/application/navigation/sign-out";
import { MobileNavigationContext } from "context-for/mobile-navigation/mobile-navigation.context";
import { useUser } from "hooks-for/users/use-user";
import logo from "images/icon-colour-light-background.svg";
import { FunctionComponent, memo, useState } from "react";
import { useLayer } from "react-laag";

import MobileNavigationAccordion from "./mobile-navigation-accordion";
import "./mobile-navigation.scss";
import { IProps } from "./mobile-navigation.types";

/**
 * The mobile navigation menu.
 * @param props.isAgentReviewEnabled Whether agent review is enabled.
 * @param props.isExploreTagsEnabled Whether explore tags is enabled.
 */
const MobileNavigation: FunctionComponent<IProps> = () => {
    const { data: user, isLoading: isUserLoading } = useUser();

    const [isOpen, setIsOpen] = useState(false);
    // Use react-laag so we can render the mobile navigation menu over all other content on the page without having to
    // manage z-indexes.
    const { triggerProps, renderLayer, layerProps } = useLayer({
        auto: true,
        isOpen,
    });

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div {...triggerProps}>
                <Button
                    className="mobile-navigation__trigger-button"
                    icon={faBars}
                    onClick={() => setIsOpen(true)}
                    isIconOnly
                    isUnstyled
                />
            </div>
            {isOpen &&
                renderLayer(
                    <SpinnerUntil data={user} isReady={!isUserLoading}>
                        <MobileNavigationContext.Provider value={{ isMenuOpen: isOpen, closeMenu }}>
                            <div className="mobile-navigation__menu" ref={layerProps.ref}>
                                <div className="mobile-navigation__header">
                                    <img src={logo} alt="EdgeTier" />
                                    <Button
                                        className="mobile-navigation__header__button"
                                        isIconOnly
                                        icon={faTimes}
                                        onClick={closeMenu}
                                        isUnstyled
                                    />
                                </div>
                                <div className="mobile-navigation__accordion">
                                    <MobileNavigationAccordion />
                                </div>
                                <div className="mobile-navigation__footer">
                                    <IconTitle
                                        icon={faUserCog}
                                        title={`${user?.firstName} ${user?.surname}` ?? "User"}
                                    />
                                    <SignOut />
                                </div>
                            </div>
                        </MobileNavigationContext.Provider>
                    </SpinnerUntil>
                )}
        </>
    );
};

export default memo(MobileNavigation);
